import * as React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import {
  LanguageOutlined,
  Logout,
  SettingsOutlined,
} from "@mui/icons-material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from "@emotion/react";
import SideList from "./sideList";
import { useLayout } from "../../../middlewares/LayoutContext";
import drawerDim from "../../../theme/drawerDimensions";
import AlertDialog from "./logout";
import { LogoAndText } from "../../../theme/JaziTheme";
import SettingsDialog from "./settings";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { changingDirection, setDirection } from "../../../Redux/themeSlice";

function SideMenu() {
  const dispatch = useDispatch();
  const { handleDrawerTransitionEnd, handleDrawerClose, mobileOpen } =
    useLayout();

  const handleOpenLogout = () => {
    setOpenLogout(true);
  };
  const { t, i18n } = useTranslation();
  const handleOpenSettings = () => {
    setOpenSettings(true);
  };

  const handleLanguageChange = (lang) => {
    dispatch(changingDirection({ value: true }));
    setTimeout(() => {
      i18n.changeLanguage(lang);
      dispatch(setDirection({ directionValue: lang === "ar" ? "rtl" : "ltr" }));
      dispatch(changingDirection({ value: false }));
    }, 500);
  };

  const theme = useTheme();
  const isRtl = theme.direction === "rtl";
  const [openLogout, setOpenLogout] = React.useState(false);
  const [openSettings, setOpenSettings] = React.useState(false);
  const drawer = (
    <div
      style={{
        display: "flex",
        background: theme.palette.whiteblack.main,
        flexDirection: "column",
        height: "100vh",
        paddingInline: theme.spacing(2),
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minHeight: drawerDim.height,
          py: 1,
          mx: 0.5,
          position: "sticky",
          top: 0,
          zIndex: 1,
          background: theme.palette.whiteblack.main,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: isRtl ? "flex-end" : "flex-start",
            zoom: 0.8,
          }}
        >
          <LogoAndText iFontSize={"1rem"} iFontWeight={700} />
        </Box>
        <Divider sx={{ my: 0, width: 0 }} />
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <SideList />
        <Divider sx={{ my: 1 }} />
      </Box>
      <List>
        <ListItem key={"language"} disablePadding>
          <ListItemButton
            sx={{
              display: "flex",
              flexDirection: isRtl ? "row-reverse" : "row",
            }}
            onClick={() =>
              handleLanguageChange(i18n.language.startsWith("en") ? "ar" : "en")
            }
          >
            <ListItemIcon
              sx={{
                width: 40,
                height: 25,
                minWidth: 40,
                display: "flex",
                flexDirection: isRtl ? "row-reverse" : "row",
              }}
            >
              <LanguageOutlined color="text" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ fontWeight: 600, fontSize: "0.875rem" }}
              primary={isRtl ? "English" : "العربية"}
            />
          </ListItemButton>
        </ListItem>
        <ListItem key={"logout"} disablePadding>
          <ListItemButton
            sx={{
              display: "flex",
              flexDirection: isRtl ? "row-reverse" : "row",
            }}
            onClick={handleOpenLogout}
          >
            <ListItemIcon
              sx={{
                width: 40,
                height: 25,
                minWidth: 40,
                display: "flex",
                flexDirection: isRtl ? "row-reverse" : "row",
              }}
            >
              <Logout color="text" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ fontWeight: 600, fontSize: "0.875rem" }}
              primary={t("logout")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem key={"settings"} disablePadding>
          <ListItemButton
            sx={{
              display: "flex",
              flexDirection: isRtl ? "row-reverse" : "row",
            }}
            onClick={handleOpenSettings}
          >
            <ListItemIcon
              sx={{
                width: 40,
                height: 25,
                minWidth: 40,
                display: "flex",
                flexDirection: isRtl ? "row-reverse" : "row",
              }}
            >
              <SettingsOutlined color="text" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ fontWeight: 600, fontSize: "0.875rem" }}
              primary={t("settings")}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerDim.width }, flexShrink: { md: 0 } }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerDim.width,
            border: "none",
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerDim.width,
            border: "none",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
      <AlertDialog
        open={openLogout}
        setOpenLogout={setOpenLogout}
      ></AlertDialog>
      <SettingsDialog open={openSettings} setOpen={setOpenSettings} />
    </Box>
  );
}
export default SideMenu;
